// extracted by mini-css-extract-plugin
export default {"wrapper":"yl-z","response":"zl-z","error":"Al-z","disabled":"Bl-z","buttons":"Cl-z","feedbackQuestionSection":"Dl-z","yesNoWrapper":"El-z"};